import { useRef, useEffect, FormEvent } from 'react'
import { motion } from 'motion/react'
import { Smile, Paperclip, Mic, Send } from 'lucide-react'

interface Props {
  value: string
  onChange: (v: string) => void
  onSend: () => void
  replyTo: any
  editingMsg: any
  onCancelContext: () => void
}

export default function MessageInput({ value, onChange, onSend, replyTo, editingMsg, onCancelContext }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => { inputRef.current?.focus() }, [])

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    onSend()
  }

  return (
    <>
      {(replyTo || editingMsg) && (
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="context-bar">
          <div className="context-info">
            <span className="context-label">{editingMsg ? 'Editing' : `Replying to ${replyTo?.username}`}</span>
            <span className="context-text">{editingMsg?.text || replyTo?.text}</span>
          </div>
          <button onClick={onCancelContext} className="context-close">✕</button>
        </motion.div>
      )}

      <form onSubmit={handleSubmit} className="input-bar glass">
        <button type="button" className="icon-btn"><Smile size={20} /></button>
        <button type="button" className="icon-btn"><Paperclip size={20} /></button>
        <input
          ref={inputRef}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="Message"
          className="msg-input"
        />
        {value.trim() ? (
          <motion.button whileTap={{ scale: 0.9 }} type="submit" className="send-btn">
            <Send size={18} />
          </motion.button>
        ) : (
          <button type="button" className="icon-btn"><Mic size={20} /></button>
        )}
      </form>
    </>
  )
}
